import _ from "lodash";
import API from "./../common/api";
import Fetch from "./fetch";
import QueryHelper from "../common/queryHelper";
import ServiceHandler from "./serviceHandler";
import CONSTANTS from "./../common/constants";

class Customers {
	static search(firstName, lastName, email) {
		const url = `${API.PREFIX}${API.CUSTOMERS.ROOT}`;
		const params = {
			firstName,
			lastName,
			email
		};

		return Fetch.get(url, params);
	}

	static getPreferredDealer(uuid, brand) {
		const url = `${API.PREFIX}${API.CUSTOMERS.PREFERRED_DEALER.replace(API.KEYS.UUID, uuid)}`;

		return Fetch.get(url, null, { 'X-TME-BRAND': brand });
	}

	static getVehiclesByUuid(uuid) {
		const url = `${window.cpAdmin.aggregatorUrl}${API.CUSTOMERS.VEHICLES.replace(API.KEYS.UUID, uuid)}`;

		return Fetch.get(url, null, undefined, false);
	}

	static getOrdersByUuid(uuid, brand) {
		const url = `${API.PREFIX}${API.CUSTOMERS.ORDERS.replace(API.KEYS.UUID, uuid)}`;

		return Fetch.get(url, null, { 'X-TME-BRAND': brand });
	}

	static async getOrderDetails(orderId) {
		const url = `${window.cpAdmin.aggregatorUrl}${API.CUSTOMERS.ORDER_DETAILS.replace(API.KEYS.ORDER_ID, orderId)}`;

		try {
			return await Fetch.get(url, null, undefined, false);
		} catch (error) {
			error.message = `Failed to load order details`;
			ServiceHandler.handleCatch(error);
		}
	}

	static getSubscriptionsByDeviceId(deviceId) {
		const url =
			`${window.cpAdmin.aggregatorUrl}${API.CUSTOMERS.SUBSCRIPTIONS.replace(API.KEYS.DEVICE_ID, deviceId)}`;
		return Fetch.get(url, null, undefined, false);
	}

	static async resendActivationMail(customer) {
		const url = `${window.cpAdmin.ssoUrl}${API.SSO.RESEND_ACTIVATION_MAIL}`;
		const headers = QueryHelper.BuildHeaders({
			lc: customer.locale,
			brand: customer.brand
		});

		const body = {
			email: customer.email
		};

		try {
			const response = await Fetch.post(url, body, headers, false);
			_.set(response, `statusCode`, CONSTANTS.STATUS_CODE.OK);
			return ServiceHandler.handle(response, `Success`, `Activation mail sent to the customer...`);
		} catch (error) {
			Customers.handleSsoError(error);
		}
	}

	static async resetPasswordMail(customer) {
		const url = `${window.cpAdmin.ssoUrl}${API.SSO.RESET_PASSWORD_EMAIL}`;
		const headers = QueryHelper.BuildHeaders({
			lc: customer.locale,
			brand: customer.brand
		});

		const body = {
			email: customer.email
		};
		try {
			const response = await Fetch.post(url, body, headers, false);
			_.set(response, `statusCode`, CONSTANTS.STATUS_CODE.OK);
			return ServiceHandler.handle(response, `Success`, `Reset password mail sent to the customer...`);
		} catch (error) {
			Customers.handleSsoError(error);
		}
	}

	static handleSsoError(error) {
		if (error.status === 404) {
			error.message = `Could not find user on TAAS, please contact an administrator.`;
		}
		ServiceHandler.handleCatch(error);
	}

	static async delete(customer) {
		const url = `${API.PREFIX}${API.CUSTOMERS.DELETE.replace(API.KEYS.UUID, customer.uuid)}`;
		try {
			const response = await Fetch.delete(url);
			return ServiceHandler.handle(response, `Success`, `Customer account was deleted...`);
		} catch (error) {
			ServiceHandler.handleCatch(error);
		}
	}

	static changeCulture(uuid, newCulture) {
		const url = `${API.PREFIX}${API.USER.CHANGE_CULTURE.replace(API.KEYS.UUID, uuid)}`;
		const body = {
			newCulture
		};
		return Fetch.patch(url, body);
	}

	static getGroups(uuid) {
		const url = `${API.PREFIX}${API.CUSTOMERS.GROUPS.replace(API.KEYS.UUID, uuid)}`;
		return Fetch.get(url);
	}

	static async canSetDealer(customer) {
		try {
			const url = `${API.PREFIX}${API.DEALER.CAN_ACTIVATE_DEALER_ROLE
				.replace(API.KEYS.UUID, customer.uuid)}`;
			const headers = QueryHelper.BuildHeaders({
				lc: customer.locale,
				brand: customer.brand
			});

			const response = await Fetch.get(url, null, headers);
			return response;
		} catch (error) {
			if(!error.statusText) {
				error.message = `Dealer role could not be activated for this customer...`;
			}
			ServiceHandler.handleCatch(error);
		}
	}

	static async activateRole(customer, group) {
		const capitalizedGroup = group.charAt(0).toUpperCase() + group.slice(1).toLowerCase();
		try {
			const url = `${API.PREFIX}${API.DEALER.ACTIVATE_DEALER_ROLE
				.replace(API.KEYS.UUID, customer.uuid)
				.replace(API.KEYS.GROUP, group)}`;
			const headers = QueryHelper.BuildHeaders({
				lc: customer.locale,
				brand: customer.brand
			});

			const response = await Fetch.patch(url, null, headers);

			return ServiceHandler.handle(response,
				`Success`,

				`${capitalizedGroup} role has been activated for this customer...`);
		} catch (error) {
			error.message = `${capitalizedGroup} role could not be activated for this customer...`;
			ServiceHandler.handleCatch(error);
		}
	}
}

export default Customers;